import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing, palette }) => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(10),
    width: '100%',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(20),
    width: '100%',
  },
  inputRadio: {
    display: 'flex',
    gap: spacing(10),
    margin: 0,
    width: '100%',
    padding: spacing(10),
    color: palette.gray[32],
    border: `1px solid ${palette.gray[32]}`,
    borderRadius: spacing(6),
    fontWeight: '500 !important',

    '& .MuiTypography-root': {
      color: palette.gray[64],
      fontSize: props => `${props?.radioOptionLabel?.fontSize} !important`,
      fontWeight: props => `${props?.radioOptionLabel?.fontWeight} !important`,
    },
  },
  radioLabel: {
    fontSize: '4px',
    fontWeight: 300,
    color: palette.gray[64],
  },
}))
